import React, { useState, useEffect, useRef } from 'react';
import {
  Button,
  Input,
  Tooltip,
  Whisper,
  Stack,
  IconButton,
  InputGroup,
  Form,
  Message,
  Table,
  SelectPicker,
  toaster,
  InputNumber
} from 'rsuite';
import CheckIcon from '@rsuite/icons/Check';
import EditIcon from '@rsuite/icons/Edit';
import CloseIcon from '@rsuite/icons/Close';
import SearchIcon from '@rsuite/icons/Search';
import globalIP from '@/GlobelIP';
import axios from 'axios';
import useTableHeight from '@/components/useTableHeight';
import CheckRoundIcon from '@rsuite/icons/CheckRound';
import WarningRoundIcon from '@rsuite/icons/WarningRound';
import { ReviewPass } from '@rsuite/icons';
import { Popconfirm } from 'antd';

interface RowDataMAT {
  id: string; // or number, depending on your data
  attributes: {
    MaterialCode: string;
    MaterialName: string;
    Cost: number;
    Type: string;
    uom: string;
    batta: string;
  };
}
interface PaginationData {
  page: number;
  pageSize: number;
  pageCount: number;
  total: number;
}
interface MetaData {
  pagination: PaginationData;
}

const MaterialNameMaster = () => {
  const { Cell } = Table;
  const { tableHeight, tableHeight2 } = useTableHeight();
  const data = ['Continue', 'Discontinue', 'All'].map(item => ({ label: item, value: item }));

  const [label, setLabel] = useState([]);
  useEffect(() => {
    fetchDatalabel();
  }, []);
  const fetchDatalabel = async () => {
    try {
      const response = await fetch(`${globalIP}/api/product-labels`);
      const json = await response.json();
      setLabel(json.data);
    } catch (error) {
      console.error('Error fetching currency data:', error);
    }
  };
  ////////////////  Function For 7 Start /////////////////

  const [material, setMaterial] = useState({
    MaterialCode: '',
    MaterialName: '',
    Cost: 0,
    Type: '',
    uom: '',
    batta: 0,
    dis: 'Continue'
  });
  // Fetch Data from API Start
  const [materialdata, setMaterialdata] = useState<RowDataMAT[]>([]);
  const [materialmeta, setMaterialmeta] = useState<MetaData>();
  const [editedRowIdsMAT, setEditedRowIdsMAT] = useState<string[]>([]);
  const [editedRowIdMAT, setEditedRowIdMAT] = useState<string>('');
  const [editedDataMAT, setEditedDataMAT] = useState<
    Record<string, Partial<RowDataMAT['attributes']>>
  >({});
  const [disMaterial, setDisMaterial] = useState([]);
  const [selectedBuyermat, setSelectedBuyermat] = useState('Continue');
  const handleBuyerChangemat = value => {
    setSelectedBuyermat(value);
  };
  const [isLoading7, setIsLoading7] = React.useState(false);
  useEffect(() => {
    fetchData7();
  }, [selectedBuyermat]);
  const fetchData7 = async () => {
    if (isLoading7) {
      return;
    }
    setIsLoading7(true);
    let disFilter = '';
    if (selectedBuyermat.length > 0) {
      disFilter = `&filters[dis][$eq]=${selectedBuyermat}`;
    }
    if (selectedBuyermat == 'All') {
      disFilter = '';
    }
    const pageResponse = await fetch(
      `${globalIP}/api/mstmaterials?populate=*&pagination[page]=1&sort[0]=id${disFilter}`
    );
    const pageJson = await pageResponse.json();
    const allData = [];
    for (let page = 1; page <= pageJson.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstmaterials?populate=*&pagination[page]=${page}&sort[0]=id${disFilter}`
      );
      const pageJson = await pageResponse.json();
      allData.push(...pageJson.data);
    }
    const responseformeta = await fetch(
      `${globalIP}/api/mstmaterials?populate=*&publicationState=preview`
    );
    const jsonmeta = await responseformeta.json();

    const response2 = await fetch(`${globalIP}/api/mstmaterials`);
    const pageJson2 = await response2.json();
    const allData2 = [];
    for (let page = 1; page <= pageJson2.meta.pagination.pageCount; page++) {
      const pageResponse = await fetch(
        `${globalIP}/api/mstmaterials?populate=*&pagination[page]=${page}`
      );
      const pageJson2 = await pageResponse.json();
      allData2.push(...pageJson2.data);
    }
    setDisMaterial(allData2);
    setMaterialmeta(jsonmeta.meta);
    setMaterialdata(allData);
    setIsLoading7(false);
  };
  const generateNextCategoryCode7 = () => {
    const nextCode = materialmeta?.pagination?.total + 1;
    return `MAT-${nextCode.toString().padStart(3, '0')}`;
  };
  const processInputRef = useRef(null);
  const handleEditRowMAT = rowData => {
    setMaterial({ ...rowData.attributes });
    setEditedRowIdMAT(rowData.id)
    setEditedRowIdsMAT(prevRowIds => [...prevRowIds, rowData.id]);
    setEditedDataMAT(prevData => ({
      ...prevData,
      [rowData.id]: { ...rowData.attributes }
    }));
    const selectedType = rowData.attributes.Type;
    if (uomMapping[selectedType]) {
      setFilteredUOM(unittype.filter(u => uomMapping[selectedType].includes(u.value)));
    } else {
      setFilteredUOM(unittype); // Default to all UOMs if no mapping is found
    }
    if (processInputRef.current) {
      processInputRef.current.focus();
    }
  };
  const resetMaterial = () => {
    setMaterial({
      MaterialCode: '',
      MaterialName: '',
      Cost: 0,
      Type: '',
      uom: '',
      batta: 0,
      dis: 'Continue'
    });
  };
  const handleCancelMaterial = rowData => {
    resetMaterial();
    setEditedRowIdMAT('');
    setEditedRowIdsMAT('');
  };
  let nextCategoryCode7 = generateNextCategoryCode7();
  const url7 = `${globalIP}/api/mstmaterials`;
  const submit7 = async e => {
    const trimmedMaterialName = material.MaterialName?.trim();
    // const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;
    // console.log('material', material);
    // return;
    // Check for empty input
    if (trimmedMaterialName === '') {
      toaster.push(
        <Message showIcon type="error">
          Please Enter {label[0]?.attributes.MaterialName}.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Stop further execution
    }
    const { Type, uom } = material;
    if (Type == null || Type == "") {
      toaster.push(
        <Message showIcon type="error">
          Please Select Material Type.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Stop further execution
    }
    if (uom == null || uom == "") {
      toaster.push(
        <Message showIcon type="error">
          Please Select UOM.
        </Message>,
        { placement: 'topCenter' }
      );
      return; // Stop further execution
    }

    // Check for special characters
    // if (specialCharPattern.test(trimmedMaterialName)) {
    //   toaster.push(
    //     <Message showIcon type="error">
    //       {label[0]?.attributes.MaterialName} should not contain special characters.
    //     </Message>,
    //     { placement: 'topCenter' }
    //   );
    //   return; // Stop further execution
    // }
    try {
      const encodedMaterialName = encodeURIComponent(trimmedMaterialName);

      const { data: materailN } = await axios.get(
        `${globalIP}/api/mstmaterials?filters[MaterialName][$eqi]=${encodedMaterialName}`
      );
      const { data: materailcode } = await axios.get(`${globalIP}/api/mstmaterials?populate=*`);
      const nextCode = materailcode.meta.pagination.total + 1;

      // if (materailcode.data.length) {
      // // Check for existing material
      // const existingMaterial = disMaterial.find(
      //   item => item.attributes.MaterialName.toLowerCase() === trimmedMaterialName.toLowerCase()
      // );

      if (materailN.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.MaterialName} {trimmedMaterialName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution
      }

      e.preventDefault();
      const nextCategoryCode = generateNextCategoryCode7();
      const formData = new FormData();
      formData.append(
        'data',
        JSON.stringify({
          ...material,
          MaterialNam: trimmedMaterialName,
          MaterialCode: `MAT-${nextCode.toString().padStart(3, '0')}`
        })
      );

      const response = await fetch(url7, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        await fetchData7(); // Wait for data to be fetched before logging
        console.log(material);

        toaster.push(
          <Message showIcon type="success">
            Data Save Successfully.
          </Message>,
          { placement: 'topCenter' }
        );
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }

    setMaterial({
      MaterialCode: '',
      MaterialName: '',
      Cost: 0,
      Type: '',
      uom: '',
      batta: 0,
      dis: 'Continue'
    });
  };

  const mattype = [
    { label: 'Metal', value: 'cmaterial' },
    { label: 'Marble', value: 'mrmaterial' },
    { label: 'Wood Material', value: 'wmaterial' },
    { label: 'Accessories Material', value: 'amaterial' },
    { label: 'Packing Material', value: 'pmaterial' }
  ];
  const unittype = [
    { label: 'Sq ft', value: 'sqft' },
    // { label: 'cu ft', value: 'cuft' },
    { label: 'CFT', value: 'cft' },
    { label: 'CBM', value: 'cbm' },
    { label: 'KG', value: 'kg' },
    { label: 'Pcs', value: 'pcs' },
    { label: 'Inch', value: 'inch' }
  ];

  const uomMapping = {
    wmaterial: ['sqft', 'cft',
      'inch', 'pcs'
    ],
    mrmaterial: ['sqft', 'cft', 'cbm',
      'inch', 'pcs'
    ],
    cmaterial: ['kg', 'pcs', 'inch'],
  };
  // const marbelUnitData = unittype.filter(item => uomMapping.mrmaterial.includes(item.value))
  // const woodUnitData = unittype.filter(item => uomMapping.wmaterial.includes(item.value))
  const [filteredUOM, setFilteredUOM] = useState(unittype);
  //  Fetch Data from API End
  const handleInputChange7 = (inputName, value, index) => {
    if (inputName === 'Type' && uomMapping[value]) {
      setFilteredUOM(unittype.filter(u => uomMapping[value].includes(u.value)));
    } else if (inputName === 'Type') {
      setFilteredUOM(unittype); // If Type is reset or has no mapping, show all UOMs
    }
    setMaterial({ ...material, [inputName]: value });
  };
  const handleMatC = async (catalogId, mat) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...materialdata,
        dis: 'Continue'
      })
    );
    fetch(`${globalIP}/api/mstmaterials/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData7();
        toaster.push(
          <Message showIcon type="success">
            {mat} Continue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };
  const handleMatD = async (catalogId, mat) => {
    const formData = new FormData();
    formData.append(
      'data',
      JSON.stringify({
        ...materialdata,
        dis: 'Discontinue'
      })
    );
    fetch(`${globalIP}/api/mstmaterials/${catalogId}`, {
      method: 'PUT',
      body: formData
    })
      .then(response => response.json())
      .then(data => {
        console.log(data);
        fetchData7();
        toaster.push(
          <Message showIcon type="success">
            {mat} Discontinue Successfully.
          </Message>,
          { placement: 'topEnd' }
        );
        // Refresh page after 2 seconds (2000 milliseconds)
      })
      .catch(error => {
        console.error(error);
      });
  };

  const handleSaveRowMAT = async (rowId: string) => {
    try {
      // const rowData = materialdata.find(row => row.id === rowId);
      if (!material) {
        console.error('Row data not found.');
        return; // Stop further execution if row data is not found
      }

      const updatedCategoryName = material?.MaterialName?.trim();
      // const specialCharPattern = /[{}\[\];:"'|<,>._?+=*&^%$#@!~`()\\]/;

      // Validate trimmed input and check for special characters
      if (!updatedCategoryName) {
        toaster.push(
          <Message showIcon type="error">
            Please enter a valid {label[0]?.attributes.MaterialName}.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution
      }
      const { Type, uom } = material;
      if (Type == null || Type == "") {
        toaster.push(
          <Message showIcon type="error">
            Please Select Material Type.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution
      }
      if (uom == null || uom == "") {
        toaster.push(
          <Message showIcon type="error">
            Please Select UOM.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop further execution
      }
      // if (specialCharPattern.test(updatedCategoryName)) {
      //   toaster.push(
      //     <Message showIcon type="error">
      //       {label[0]?.attributes.MaterialName} should not contain special characters.
      //     </Message>,
      //     { placement: 'topCenter' }
      //   );
      //   return; // Stop further execution
      // }
      const { data: updatematerailN } = await axios.get(
        `${globalIP}/api/mstmaterials?filters[MaterialName][$eqi]=${updatedCategoryName}&filters[id][$ne]=${editedRowIdMAT}`
      );
      if (updatematerailN.data.length) {
        toaster.push(
          <Message showIcon type="warning">
            {label[0]?.attributes.MaterialName} {updatedCategoryName} already exists.
          </Message>,
          { placement: 'topCenter' }
        );
        return; // Stop the function if validation fails
      }
      // const updatedRowData: RowDataMAT = {
      //   ...rowData,
      //   attributes: {
      //     ...rowData.attributes,
      //     ...editedDataMAT[rowId],
      //     MaterialName: updatedCategoryName
      //   }
      // };

      const response = await fetch(`${globalIP}/api/mstmaterials/${editedRowIdMAT}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ data: { ...material, MaterialName: updatedCategoryName } })
      });

      if (response.ok) {
        // If the API call is successful, update the data
        fetchData7();
        resetMaterial('')
        setEditedRowIdMAT('')
        setEditedDataMAT(prevData => ({
          ...prevData,
          [editedRowIdMAT]: { ...material, MaterialName: updatedCategoryName } // Ensure UI updates correctly
        }));
        setEditedRowIdsMAT(prevRowIds => [...new Set([...prevRowIds, editedRowIdMAT])]);
      } else {
        console.error('Failed to save data');
      }
    } catch (error) {
      console.error('Error occurred while saving data', error);
    }
  };
  const [filteredUOMsMAT, setFilteredUOMsMAT] = useState({});
  const handleInputChangeMAT = (rowId, fieldName, value) => {
    setEditedDataMAT(prevData => {
      const updatedData = { ...prevData };
      if (!updatedData[rowId]) {
        updatedData[rowId] = { ...materialdata.find(row => row.id === rowId).attributes };
      }

      updatedData[rowId][fieldName] = value;

      // If the Type field is changed, update filtered UOMs for that row
      if (fieldName === 'Type') {
        setFilteredUOMsMAT(prevUOMs => ({
          ...prevUOMs,
          [rowId]: uomMapping[value]
            ? unittype.filter(u => uomMapping[value].includes(u.value))
            : unittype
        }));

        // Reset UOM value if the selected type changes
        updatedData[rowId]['uom'] = '';
      }

      return updatedData;
    });
  };

  ////////////////  Function For 7 End /////////////////
  ////////////////  Searching For 7 Start /////////////////
  const [searchQuery7, setSearchQuery7] = useState('');
  const [filterStatus7, setFilteredStatus7] = useState('Continue');
  const handleSearch7 = value => {
    setSearchQuery7(value);
  };
  const [matairlFilterData, setMatairlFilterData] = useState([]);

  useEffect(() => {
    const matairlFilterData = materialdata
      .slice()
      .reverse()
      .filter(item => {
        const MaterialName = item.attributes.MaterialName
          ? item.attributes.MaterialName.toLowerCase()
          : '';
        return MaterialName.includes(searchQuery7.toLowerCase());
      });
    setMatairlFilterData(matairlFilterData);
  }, [materialdata, filterStatus7, searchQuery7]);
  ////////////////  Searching For 7 End /////////////////
  return (
    <>
      <Stack justifyContent="space-between" style={{ marginBottom: '10px' }} className="mstr-panel">
        <Stack spacing={5} className="mstr-panel1">
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <Stack>
                <b>{label[0]?.attributes.MaterialName}</b>
                <p style={{ color: 'red' }}>*</p>
              </Stack>
            </Form.ControlLabel>
            <Input
              id="MaterialName"
              name="MaterialName"
              autoComplete="off"
              ref={processInputRef}
              // style={{ width: '180%' }}
              value={material && material.MaterialName ? material.MaterialName : ''}
              onChange={value => handleInputChange7('MaterialName', value, 0)}
              onPressEnter={submit7}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <Stack>
                <b>Type</b>
                <p style={{ color: 'red' }}>*</p>
              </Stack>
            </Form.ControlLabel>
            <SelectPicker
              data={mattype}
              id="Type"
              name="Type mstr-btn1"
              cleanable={false}
              // style={{ width: '180%' }}
              value={material && material.Type ? material.Type : ''}
              onChange={value => handleInputChange7('Type', value, 0)}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <Stack>
                <b>UOM</b>
                <p style={{ color: 'red' }}>*</p>
              </Stack>
            </Form.ControlLabel>
            <SelectPicker
              data={filteredUOM}
              id="uom"
              name="uom mstr-btn1"
              cleanable={false}
              // style={{ width: '180%' }}
              value={material && material.uom ? material.uom : ''}
              onChange={value => handleInputChange7('uom', value, 0)}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>Cost</b>
            </Form.ControlLabel>
            <InputNumber
              step={null}
              min={0}
              id="Cost"
              name="Cost"
              value={material && material.Cost ? material.Cost : ''}
              onChange={value => handleInputChange7('Cost', value, 0)}
            />
          </Stack>
          <Stack direction="column" alignItems="flex-start">
            <Form.ControlLabel>
              <b>Batta</b>
            </Form.ControlLabel>
            <InputNumber
              step={null}
              min={0}
              id="batta"
              name="batta"
              value={material && material.batta ? material.batta : 0}
              onChange={value => handleInputChange7('batta', value, 0)}
            />
          </Stack>
          {editedRowIdMAT ? (
            <Button appearance="primary" color="cyan" onClick={handleSaveRowMAT} style={{ marginTop: '18px' }}>
              {' '}
              Update
            </Button>
          ) : (
            <Button appearance="primary" color="cyan" onClick={submit7} style={{ marginTop: '18px' }}>
              {' '}
              Add
            </Button>
          )}

        </Stack>

        <Stack className="mstr-search" spacing={5} style={{ marginTop: '16px', marginLeft: '7px' }}>
          <SelectPicker
            data={data}
            placeholder="Status"
            labelKey="label"
            value={selectedBuyermat}
            onChange={handleBuyerChangemat}
            searchable={false}
            valueKey="value"
            size="md"
            appearance="default"
            style={{ width: 130 }}
            cleanable={false}
          />
          <InputGroup inside>
            <Input placeholder="Search" type="text" value={searchQuery7} onChange={handleSearch7} />
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
          </InputGroup>
        </Stack>
      </Stack>
      <Table
        rowHeight={60}
        data={matairlFilterData}
        height={tableHeight}
        rowKey="id"
        bordered
        cellBordered
        loading={isLoading7}
      >
        <Table.Column width={60} fixed>
          <Table.HeaderCell>
            <b>Sr. No.</b>
          </Table.HeaderCell>
          <Cell>{(_, rowIndex) => +rowIndex + 1}</Cell>
        </Table.Column>

        <Table.Column width={130} flexGrow={1}>
          <Table.HeaderCell>
            <b>{label[0]?.attributes.MaterialName}</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsMAT.includes(rowData.id) ? (
              //   <Input
              //     value={editedDataMAT[rowData.id]?.MaterialName || ''}
              //     onChange={value => handleInputChangeMAT(rowData.id, 'MaterialName', value)}
              //   />
              // ) : (
              rowData.attributes.MaterialName
              // )
            }
          </Table.Cell>
        </Table.Column>

        <Table.Column width={150}>
          <Table.HeaderCell>
            <b>Type</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsMAT.includes(rowData.id) ? (
              //   <SelectPicker
              //     data={mattype}
              //     value={editedDataMAT[rowData.id]?.Type || ''}
              //     onChange={value => handleInputChangeMAT(rowData.id, 'Type', value)}
              //   />
              // ) : (
              mattype.find(item => item.value === rowData.attributes.Type)?.label ||
              rowData.attributes.Type
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={80}>
          <Table.HeaderCell>
            <b>UOM</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsMAT.includes(rowData.id) ? (
              //   <SelectPicker
              //     data={filteredUOMsMAT[rowData.id] || unittype} // Use row-specific UOMs
              //     value={editedDataMAT[rowData.id]?.uom || ''}
              //     onChange={value => handleInputChangeMAT(rowData.id, 'uom', value)}
              //   />
              // ) : (
              (filteredUOMsMAT[rowData.id] || unittype).find(
                item => item.value === rowData.attributes.uom
              )?.label || rowData.attributes.uom
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={80}>
          <Table.HeaderCell>
            <b>Cost</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsMAT.includes(rowData.id) ? (
              //   <InputNumber
              //     step={null}
              //     min={0}
              //     value={editedDataMAT[rowData.id]?.Cost || 0}
              //     onChange={value => handleInputChangeMAT(rowData.id, 'Cost', value)}
              //   />
              // ) : (
              rowData.attributes.Cost
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={80}>
          <Table.HeaderCell>
            <b>Batta</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              // editedRowIdsMAT.includes(rowData.id) ? (
              //   <InputNumber
              //     step={null}
              //     min={0}
              //     value={editedDataMAT[rowData.id]?.batta || 0}
              //     onChange={value => handleInputChangeMAT(rowData.id, 'batta', value)}
              //   />
              // ) : (
              rowData.attributes.batta
              // )
            }
          </Table.Cell>
        </Table.Column>
        <Table.Column width={100} fixed="right">
          <Table.HeaderCell>
            <b>Action</b>
          </Table.HeaderCell>
          <Table.Cell>
            {rowData =>
              editedRowIdsMAT.includes(rowData.id) ? (
                <div>
                  {/* <IconButton
                    size="sm"
                    icon={<CheckIcon />}
                    active
                    onClick={() => handleSaveRowMAT(rowData.id)}
                    style={{ marginRight: '10px' }}
                  /> */}
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowMAT(rowData)}
                    style={{ marginRight: '10px' }}
                  />
                  <IconButton
                    size="sm"
                    icon={<CloseIcon />}
                    active
                    onClick={handleCancelMaterial}
                  // onClick={() =>
                  //   setEditedRowIdsMAT(prevRowIds => prevRowIds.filter(id => id !== rowData.id))
                  // }
                  />
                </div>
              ) : (
                <div>
                  <IconButton
                    size="sm"
                    icon={<EditIcon />}
                    active
                    onClick={() => handleEditRowMAT(rowData)}
                  />
                  {rowData.attributes.dis === 'Discontinue' ? (
                    <Popconfirm
                      title="Continue Material"
                      description="Are you sure you want to continue this Material?"
                      onConfirm={() => handleMatC(rowData.id, rowData.attributes.MaterialName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Continue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<CheckRoundIcon />}
                          active
                          style={{ marginLeft: '10px' }}
                          // onClick={() => handleMatC(rowData.id, rowData.attributes.MaterialName)}
                        />
                      </Whisper>
                    </Popconfirm>
                  ) : (
                    <Popconfirm
                      title="Discontinue Material"
                      description="Are you sure you want to discontinue this Material?"
                      onConfirm={() => handleMatD(rowData.id, rowData.attributes.MaterialName)}
                      // onCancel={cancel}
                      okText="Yes"
                      cancelText="No"
                    >
                      <Whisper placement="auto" speaker={<Tooltip>Discontinue</Tooltip>}>
                        <IconButton
                          size="sm"
                          icon={<ReviewPass />}
                          active
                          style={{ marginLeft: '10px' }}
                          // onClick={() => handleMatD(rowData.id, rowData.attributes.MaterialName)}
                        />
                      </Whisper>
                    </Popconfirm>
                  )}
                </div>
              )
            }
          </Table.Cell>
        </Table.Column>
      </Table>
      <div>
        <p>
          <small>Total row:{matairlFilterData.length}</small>
        </p>
      </div>
    </>
  );
};

export default MaterialNameMaster;
